/**
 * @jsxRuntime classic
 * @jsx jsx
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { fg } from '@atlaskit/platform-feature-flags';
import { cssVar } from '../../../constants';
var beforeElementStyles = css({
  display: 'flex',
  height: '16px',
  alignItems: 'center',
  justifyContent: 'center',
  insetBlockStart: "var(--ds-space-0, 0px)"
});

// To be removed with platform-component-visual-refresh (BLU-2992)
var beforeElementStylesOld = css({
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  justifyContent: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  borderRadius: "var(".concat(cssVar.borderRadius, ")"),
  insetBlockStart: "var(--ds-space-0, 0px)"
});
var Before = function Before(_ref) {
  var elemBefore = _ref.elemBefore;
  return elemBefore ? jsx("span", {
    css: fg('platform-component-visual-refresh') ? beforeElementStyles : beforeElementStylesOld
  }, elemBefore) : null;
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Before;